var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    staticClass: "mx-auto overflow-visible",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.data._id ? _c('span', [_vm._v("유통데이터 활용 주요자료 수정")]) : _c('span', [_vm._v("유통데이터 활용 주요자료 등록")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("상이름")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "ex) 대상",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.data.awardName,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "awardName", $$v);
      },
      expression: "data.awardName"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("제목")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.data.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "subject", $$v);
      },
      expression: "data.subject"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("팀명")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.data.name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "name", $$v);
      },
      expression: "data.name"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("작성일")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.$dayjs(_vm.data.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      "type": "datetime-local",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function change(value) {
        return _vm.data.createdAt = _vm.$dayjs(value).toDate();
      }
    }
  }), _c('div', {
    staticClass: "text-caption primary--text"
  }, [_vm._v("* 작성일이 최신일수록 상단에 노출됩니다")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("카테고리")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.data.category,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "category", $$v);
      },
      expression: "data.category"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("분석자료 링크")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "https://"
    },
    model: {
      value: _vm.data.link,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "link", $$v);
      },
      expression: "data.link"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("상세내용")])]), _c('v-card', [_c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.data.content,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "content", $$v);
      },
      expression: "data.content"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("분석자료 내용")])]), _c('v-card', [_c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.data.content2,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "content2", $$v);
      },
      expression: "data.content2"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }